/*jshint esversion: 6 */
import Ajax from '../common/Ajax';
import * as Utils from '../common/Utils';
import dialogPolyfill from "dialog-polyfill";
import { Modal } from "bootstrap";

let WidgetVideoRatingForm = function (config) {

    let id = null;
    let btn = document.querySelector('button#btn-cite-show');
    if (btn) {
        id = btn.getAttribute('data-id');
    }

    config.route = (typeof config.route !== 'undefined') ? config.route : '/widget/video/%id%/rating';
    config.id = (typeof config.id !== 'undefined') ? config.id : id;

    let questionContainers = document.getElementsByClassName('video-rating-question-container');


    const modal = document.querySelector('dialog');

    if (modal) {
        dialogPolyfill.registerDialog(modal);
    }

    let buildForm = function (id) {
        config.id = id;
        for (let i = 0; i < questionContainers.length; i++) {

            let questionID = questionContainers[i].getAttribute('data-question');
            let hiddenInput = questionContainers[i].getElementsByTagName('input')[0];
            let buttons = questionContainers[i].getElementsByTagName('button');

            for (let i = 0; i < buttons.length; i++) {
                let button = buttons[i];
                button.onclick = function () {

                    let stars = button.getAttribute('value');
                    console.log('You gave question ' + questionID + ' ' + stars + ' stars');
                    hiddenInput.value = stars;

                    for (let y = 0; y < buttons.length; y++) {
                        buttons[y].classList.remove('star-rating-checked');
                        if (i >= y) {
                            buttons[y].classList.add('star-rating-checked');
                        }
                    }

                    return false;
                };

                // the following two listeners highlight all stars upto and including the one hovered over

                button.addEventListener('mouseenter',function () {

                    for (let y = 0; y < buttons.length; y++) {
                        if (i >= y) {
                            buttons[y].classList.add('star-rating-checked-temporary');
                        }
                    }

                    return false;
                });
                button.addEventListener('mouseleave',function () {

                    for (let y = 0; y < buttons.length; y++) {
                        buttons[y].classList.remove('star-rating-checked-temporary');
                    }

                    return false;
                });
            }

        }

        openDialog();
    };

    /**
     * Create the route string
     *
     * @param type
     * @param id
     *
     * @returns {string}
     */
    let createRoute = function (id) {
        return Utils.generateRouteFromPattern({
            pattern: {
                '%id%': id
            },
            route: config.route,
            env: config.env,
            locale: config.locale
        });
    };

    let sendRequest = function (payload) {
        let route = createRoute(config.id);
        Ajax.postRequest(route, payload, function () {
            Utils.displayAlert('Thank you for rating the video', 'success');
        }, function () {
            Utils.displayAlert('Please try again', 'error');
        })
    };

    let submitForm = function () {
        let form = document.forms["video-rating"];
        let sendData = true;
        let payload = {
            'rating': []
        };

        for (let x = 1; x <= 3; x++) {
            let element_name = "question_" + x;
            let element = form[element_name];
            let questionID = form[element_name].getAttribute('data-question-id');

            if (element.value === 0 || element.value === "" || element.value === "0") {
                sendData = false;
                break;
            } else {
                payload.rating.push({
                    'id': questionID,
                    'value': element.value
                });
            }
        }

        if (sendData) {
            // Send AJAX request
            sendRequest(payload);
        }

        closeDialog();
    };

    let getDialogOpenBtn = function () {
        return document.querySelector('#btn-cite-show');
    };

    let openDialog = function () {
        let dialog = getDialog();
        dialog.show();

        // handle bootstrap modals too
        if (dialog.parentElement.classList.contains("modal")) {
            let element = document.getElementById(dialog.parentElement.id);
            if (element) {
                let modal = Modal.getInstance(element) || new Modal(dialog.parentElement);
                modal.show();
            }
        }
    };

    let closeDialog = function () {
        let dialog = getDialog();
        dialog.close();

        // handle bootstrap modals too
        if (dialog.parentElement.classList.contains("modal")) {
            let element = document.getElementById(dialog.parentElement.id);
            if (element) {
                let modal = Modal.getInstance(element);
                modal.hide();
            }
        }
    };

    let getDialog = function () {
        return document.querySelector('dialog');
    };

    let getDialogSubmitBtn = function () {
        return document.querySelector('#btn-cite-close');
    };


    return {
        buildForm: buildForm,
        submitForm: submitForm,
        getDialogOpenBtn: getDialogOpenBtn,
        getDialogSubmitBtn: getDialogSubmitBtn,
        openDialog: openDialog,
        closeDialog: closeDialog
    };

};

export default WidgetVideoRatingForm;